import { createContext, useContext, useEffect, useState } from "react";
import en from "./en";
import es from "./es";

const DICTS = { en, es };
const LanguageContext = createContext(null);

function lookup(dict, key) {
  return key.split(".").reduce((obj, part) => (obj == null ? undefined : obj[part]), dict);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => (localStorage.getItem("af_lang") === "es" ? "es" : "en"));

  useEffect(() => {
    localStorage.setItem("af_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const value = lookup(DICTS[lang], key);
    if (value !== undefined) return value;
    const fallback = lookup(en, key);
    return fallback !== undefined ? fallback : key;
  };

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
